import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=5e7cf5fb&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=5e7cf5fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7cf5fb",
  null
  
)

export default component.exports